// INTENT: Minimal JavaScript entrypoint specifically for Web Awesome layout pages (wa_application.html.erb).
// EXPECTED OUTCOME: Initializes Hotwire Stimulus runtime, registers WaFormController and WaThemeController, loads Web Awesome web components locally, and loads Turbo.
// CAVEAT/TRAP: Web Awesome components are bundled via esbuild directly from @web.awesome.me/webawesome-pro npm package.
import { Application } from "@hotwired/stimulus"
import "@hotwired/turbo-rails"
import WaFormController from "./controllers/wa_form_controller"
import WaThemeController from "./controllers/wa_theme_controller"
import WaRoleCardController from "./controllers/wa_role_card_controller"

// INTENT: Import Web Awesome Pro custom element components into the esbuild bundle.
// EXPECTED OUTCOME: Registers <wa-input>, <wa-button>, <wa-icon>, <wa-card>, <wa-divider>, <wa-callout>, etc. locally without CDN dependencies.
import "@web.awesome.me/webawesome-pro/dist/components/button/button.js"
import "@web.awesome.me/webawesome-pro/dist/components/input/input.js"
import "@web.awesome.me/webawesome-pro/dist/components/icon/icon.js"
import "@web.awesome.me/webawesome-pro/dist/components/card/card.js"
import "@web.awesome.me/webawesome-pro/dist/components/divider/divider.js"
import "@web.awesome.me/webawesome-pro/dist/components/callout/callout.js"
import "@web.awesome.me/webawesome-pro/dist/components/badge/badge.js"
import "@web.awesome.me/webawesome-pro/dist/components/spinner/spinner.js"
import "@web.awesome.me/webawesome-pro/dist/components/tooltip/tooltip.js"
import "@web.awesome.me/webawesome-pro/dist/components/toast/toast.js"
import "@web.awesome.me/webawesome-pro/dist/components/toast-item/toast-item.js"
import "@web.awesome.me/webawesome-pro/dist/components/page/page.js"
import "@web.awesome.me/webawesome-pro/dist/components/radio/radio.js"
import "@web.awesome.me/webawesome-pro/dist/components/radio-group/radio-group.js"
import "@web.awesome.me/webawesome-pro/dist/components/tab/tab.js"
import "@web.awesome.me/webawesome-pro/dist/components/tab-group/tab-group.js"
import "@web.awesome.me/webawesome-pro/dist/components/tab-panel/tab-panel.js"

// INTENT: Start Stimulus instance and register Web Awesome controllers.
// EXPECTED OUTCOME: Form submission buttons gain automatic loading states and layout gains dynamic light/dark theme management.
// CAVEAT/TRAP: Register controllers explicitly with the Stimulus application instance.
window.Stimulus = Application.start()
Stimulus.register("wa-form", WaFormController)
Stimulus.register("wa-theme", WaThemeController)
Stimulus.register("wa-role-card", WaRoleCardController)

// INTENT: Register zero-latency Web Awesome icon resolver using installed @awesome.me/kit-2bee521180 package.
// EXPECTED OUTCOME: Converts kit Font Awesome icon vectors into inline SVGs in-memory for instant rendering without CDN network calls.
// CAVEAT/TRAP: Fully self-hosted from node_modules; zero external network requests to Font Awesome CDN.
import { registerIconLibrary } from "@web.awesome.me/webawesome-pro/dist/components/icon/library.js"
import { byPrefixAndName } from "@awesome.me/kit-2bee521180/icons"

registerIconLibrary('default', {
  resolver: name => {
    const icon = byPrefixAndName['fas']?.[name]
    if (icon) {
      const [width, height, , , path] = icon.icon
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}" fill="currentColor"><path d="${path}"/></svg>`
      return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
    }
  }
})
